import { HeaderCell } from ".";
import { HeaderCellMenuItem } from "./HeaderCellMenuItem";
import { useAtom } from "jotai";
import { showLabelHintsAtom, showReadableLabelAtom } from "../../../state";

export function LabelHeaderCell(props) {
    const [showReadableLabel, setShowReadableLabel] = useAtom(
        showReadableLabelAtom,
    );
    const [showLabelHints, setShowLabelHints] = useAtom(showLabelHintsAtom);

    return (
        <HeaderCell {...props}>
            <HeaderCellMenuItem
                onClick={() => setShowReadableLabel(!showReadableLabel)}
                label={
                    showReadableLabel
                        ? "Show system labels"
                        : "Show readable labels"
                }
            />
            <HeaderCellMenuItem
                onClick={() => setShowLabelHints(!showLabelHints)}
                label={showLabelHints ? "Hide hints" : "Show hints"}
            />
        </HeaderCell>
    );
}
